import { Sun, Moon } from '@phosphor-icons/react'

interface ThemeToggleProps {
  theme: string
  toggleTheme: () => void
}

export function ThemeToggle({ theme, toggleTheme }: ThemeToggleProps) {
  return (
    <button
      onClick={toggleTheme}
      className="relative w-16 h-7 rounded-full bg-sky-500/20 transition-colors flex items-center px-1"
      title="Toggle theme"
    >
      <Sun 
        size={14} 
        weight="bold"
        className={`absolute left-1.5 transition-opacity ${
          theme === 'dark' ? 'opacity-40' : 'opacity-100'
        } text-sky-500`}
      />
      <Moon 
        size={14} 
        weight="bold"
        className={`absolute right-1.5 transition-opacity ${
          theme === 'dark' ? 'opacity-100' : 'opacity-40'
        } text-sky-300`}
      />
      <div
        className={`absolute top-1 w-5 h-5 rounded-full transition-transform ${
          theme === 'dark' ? 'translate-x-9 bg-sky-300' : 'translate-x-0 bg-sky-500'
        }`}
      />
      <span className="sr-only">Toggle theme</span>
    </button>
  )
} 